import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Bee(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            A honeybee like me might work anywhere from just a few hours a day
            to about 12, depending on its role in the beehive. For example,
            worker bees like me are tasked with the daily foraging of nectar or
            pollen. We normally spend nearly every hour of daylight outside -but
            as soon as it gets dark we head back to the nest and relax, though
            it's getting harder and harder to find places to build our nests
            these days.
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Do you know what music we enjoy?
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Human scientific studies claim that Honey Bees prefer the music
            genre of "Bee-Bop" more than anything & I can't speak for all bees,
            but I know that's true for me and my mates. If you fancy a Bee-Bop
            with a Honey Bee then let's have a dance.
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              let's have a dance.
            </button>{" "}
            If you you're too human to dance with bugs then{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              stand over there.
            </button>{" "}
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Bzzz, you know what? You're not bad! Waggle back and forth as you
            move forward in a straight line, then circle around to repeat the
            dance. The length of the middle line, called the waggle run, shows
            roughly how far it is to the nearest flower patch. Do you know where
            the nearest one is? If in doubt, just shake it!
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            Ok, I see you're too cool to dance with a bee, off you go then you
            bore!
          </p>
        </div>
      </div>
    );
  }
}

export default Bee;
